import { render, staticRenderFns } from "./ImputedCostsListTable.vue?vue&type=template&id=72e0b952&"
import script from "./ImputedCostsListTable.vue?vue&type=script&lang=js&"
export * from "./ImputedCostsListTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports